import { render, staticRenderFns } from "./high-commission.vue?vue&type=template&id=545cb523&scoped=true&"
import script from "./high-commission.vue?vue&type=script&lang=js&"
export * from "./high-commission.vue?vue&type=script&lang=js&"
import style0 from "./high-commission.vue?vue&type=style&index=0&id=545cb523&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545cb523",
  null
  
)

export default component.exports